import modals from "webmodals/modals";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import AutoQuery from "servicestack/auto-query/auto-query";
import JobSchedulerPrompt from "emun.report/job-scheduler/job-scheduler-prompt";

export default class JobSchedulerController extends BasicAutoQueryController {
  constructor() {
    super();
    let $ctrl = this;
  }
  $onInit() {
    console.info("jobScheduler");
    const $ctrl = this;
    super.$onInit && super.$onInit();
    $ctrl.query = new AutoQuery($ctrl.getQueryOptions());
  }
  getQueryOptions() {
    const $ctrl = this;
    return {
      url: "QueryScheduledJobs.json",
      pageSize: 12,
      //append: true,
      autoLoad: true,
      hideLeftNav: true,
      filters: [{ groupBy: "JobType", title: "JobType" }],
      sortOptions: {
        JobType: "Job Type: A to Z",
        "-JobType": "Job Type: Z to A",
        JobDescription: "Job Description: A to Z",
        "-JobDescription": "Job Description: Z to A",
        CreatedOn: "Created On: Latest",
        "-CreatedOn": "Created On: Oldest",
      },
    };
  }
  create() {
    const $ctrl = this;
		JobSchedulerPrompt.open({}).then(() => $ctrl.query.load());
  }
  edit(job) {
    const $ctrl = this;
    JobSchedulerPrompt.open({ job: job }).then(() => $ctrl.query.load());
  }
  delete(job) {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Job")
      .result.then(function () {
        $ctrl.bus
          .send("DeleteScheduledJob", job)
          .then(() => {
            $ctrl.query.load();
          });
      });
  }
}
